import React from "react";
import KnowledgeManagement from "./KnowledgeManagement";
import { labels } from "../../../localization/labels";
import { Comparator } from "react-bootstrap-table2-filter";
import { paths } from "../../paths";
import KnowledgeService from "../../../services/KnowledgeService";
import TableUtils from "../../core/Table/TableUtils";
import AdvancedSearchComponent from "../page/AdvancedSearchComponent/AdvancedSearchComponent";
import RouteUtil from "../../../utils/RouteUtil";
import { selectFilter } from "../../../services/FilteringUtils";
import PathUtil from "../../../utils/PathUtil";
import { constants } from "../../../utils/Constants";
import { messages } from "../../../localization/messages";
import SecurityUtils from "../../../utils/SecurityUtils";
class KnowledgeManagementContainer extends AdvancedSearchComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      advancedSearchParams: RouteUtil.getLocationParameter(
        props,
        "advancedSearchParams"
      ),
      contextMenuItems: [
        {
          label: labels.newTab,
          callback: this.openInNewTab
        },
        {
          label: labels.reactivateItem,
          callback: this.handleOnReactivate,
          menuItemType: constants.MENU_ITEM_TYPE_REACTIVATE,
          checkSecurity: true
        },
        {
          label: labels.deleteItem,
          callback: this.handleOnDelete,
          menuItemType: constants.MENU_ITEM_TYPE_DELETE,
          checkSecurity: true
        }
      ]
    };
    this.customContextRef = React.createRef();
    this.knowledgeService = new KnowledgeService();
  }

  handleOnDelete = entity => {
    const confirmed = window.confirm(messages.delete_selected_confirm_message);
    if (confirmed) {
      this.onDeleteData(entity);
    }
  };

  initialSortInfo() {
    return {
      orderBy: "id",
      direction: "desc"
    };
  }

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.id, Comparator.EQ)
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      formatter: TableUtils.textFormatter,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.name)
    },
    {
      dataField: "description",
      text: labels.description,
      formatter: TableUtils.textFormatter,
      sort: true,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.description)
    }
  ]);

  getComponentTitle = () => {
    return labels.knowledgeManagement;
  };

  loadData = pageInfo => {
    this.adjustPageInfo(pageInfo);
    this.prepareCall(
      this.knowledgeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate() {
    this.shouldResetFilters = true;
    super.componentDidUpdate();
  }

  onRowClick = (_, row) => {
    if (
      SecurityUtils.userHasPermissionOnEntity(row, constants.OPERATION_READ)
    ) {
      const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, row.id);
      this.changePath(itemPath, row.name);
    } else return undefined;
  };

  onDeleteData = knowledgeItem => {
    this.prepareCall(
      this.knowledgeService.deleteEntity(
        knowledgeItem,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onReactivateData = knowledgeItem => {
    knowledgeItem.isDeleted = false;
    this.prepareCall(
      this.knowledgeService.putEntity(
        knowledgeItem,
        this.onDataReactivateResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  handleCreate = () => {
    this.changePath(paths.KNOWLEDGE_ITEM, labels.knowledgeItem);
  };

  getAdvancedSearchParams = () => {
    var { advancedSearchParams } = this.state;
    if (
      advancedSearchParams === undefined ||
      Object.entries(advancedSearchParams).length === 0
    ) {
      advancedSearchParams = {
        correctWords: selectFilter(),
        phrases: selectFilter(),
        anyWords: selectFilter(),
        nonWords: selectFilter(),
        extensions: {
          ...selectFilter(),
          nestedId: "id"
        },
        classifications: {
          ...selectFilter(),
          nestedId: "id"
        }
      };
    }
    return advancedSearchParams;
  };

  openInNewTab = row => {
    const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, row.id);
    window.open(itemPath, "_blank", "noopener");
  };

  createSelectRow = () => {};

  render() {
    return (
      <KnowledgeManagement
        {...this.renderProps()}
        cellEditProps={this.cellEditProps}
        handleCreate={this.handleCreate}
        contextMenuItems={this.state.contextMenuItems}
      />
    );
  }
}

export default KnowledgeManagementContainer;
